module.exports = __webpack_public_path__ + "static/media/Grapes.f58ba81e.png";